



import ForgotUserSection from '../sections/forgot_username/template_01';




import "./style.css";


const ForgotUserPage = ()=>{
  
return (
  <div id="forgotUserPage" class="page ">
  
  

  
  <ForgotUserSection desktopTitleToggle={ true }
    mobileTitleToggle={ true } />
  
  
  

  
</div>
)
}

export default ForgotUserPage;